import { FLAGS } from 'shared/utils/launchdarkly/flags';
/* For use in helpers or outside of hook context */
export var getFlagValue = function (flag) {
    var flagValue = FLAGS[flag].useFlag();
    return flagValue;
};
/*
  `useFlagValue` directly returns the result of `FLAGS['flag name'].useFlag()` using the provided default array of the
  FLAGS constant as a type shortcut. Intended for use with non-boolean flags.
*/
export var useFlagValue = function (flag) {
    return getFlagValue(flag);
};
